<template>
  <div class="header">
    <div class="session-wrapper">
      <div class="name">{{ session.MovieName }}</div>
      <div class="tag" v-if="session.Format">{{ session.Format.Name }}</div>
      <div class="tag">{{ movie.Rate }}</div>
      <!-- <div class="tag">3D</div> -->
      <!-- <div class="tag">IMAX</div> -->
      <!-- <div class="tag">16+</div> -->
      <!-- <div class="button-close" @click="closeFrame">
        <span class="btn-icon fa fa-close"></span>
      </div>-->
    </div>
    <div class="cinema-wrapper">
      <div class="cinema-name">{{ theatre.Name }},</div>
      <div class="cinema-hall-name" v-if="session.Hall">
        {{ theatre.NameFull }}, {{ session.Hall.Name }}
      </div>
    </div>
    <div class="time-wrapper">
      <div class="time-date" v-if="session.DateTime">
        {{ session.DateTime | moment('dddd, D MMMM в H:mm') }}
      </div>
    </div>
    <div class="contact" v-if="setting.supportPhone">
      <div class="contact-label">Служба поддержки</div>
      <div class="contact-number">{{ setting.supportPhone }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Header',

  computed: mapState(['theatre', 'session', 'movie', 'setting']),

  mounted() {
    this.$moment.locale('ru');
  },
};
</script>

<style lang="scss">
%circle-btn {
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 10px;
  height: 40px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  position: absolute;
  top: 20px;
  padding: 0;
  width: 42px;
  height: 42px;
  border: 2px solid #fff;
  border-radius: 100%;
  opacity: 0.3;
  cursor: pointer;
  justify-content: center;
  transition: 0.15s ease-in-out;
  &:hover {
    opacity: 1;
  }
}

.header {
  padding: 30px;
  border-bottom: 1px solid #cdcfd024;
  background: #24262ce6;
  z-index: 10002;
  position: static;
  top: 0;
  left: 0;
  right: 0;
  height: 150px;
  box-sizing: border-box;
  .contact {
    display: none;
    position: absolute;
    right: 90px;
    top: 25px;
    &-label {
      text-transform: uppercase;
      font-size: 10px;
      line-height: 12px;
      letter-spacing: 1px;
      color: #fff;
      color: #fffc;
      margin-bottom: 2px;
    }
    &-number {
      font-size: 17px;
      line-height: 20px;
      font-weight: 500;
      letter-spacing: 0.5px;
      color: #fff;
    }
  }
}

.session-wrapper,
.cinema-wrapper,
.time-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}

.session-wrapper {
  margin-bottom: 2px;
  padding-right: 60px;
  .name {
    margin-right: 10px;
    width: auto;
    font-size: 20px;
    flex: 0, 1, auto;
    line-height: 22px;
    color: #fff;
  }
  .tag {
    display: flex;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    width: auto;
    margin-top: 3px;
    margin-right: 5px;
    padding: 4px 5px;
    text-align: center;
    font-size: 12px;
    line-height: 8px;
    color: #000;
    background-color: #fff9;
    border-radius: 3px;
    font-family: HelveticaNeue, Helvetica Neue, HelveticaNeueRoman,
      HelveticaNeue-Roman, Helvetica Neue Roman, TeXGyreHerosRegular,
      HelveticaNeueLocal, Helvetica, Tahoma, Geneva, Arial, sans-serif;
  }
}

.cinema {
  &-wrapper {
    color: #919295;
    font-size: 14px;
    padding-right: 60px;
  }
  &-name {
    margin-right: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: top;
    display: inline-block;
    width: auto;
    font-family: HelveticaNeue, Helvetica Neue, HelveticaNeueRoman,
      HelveticaNeue-Roman, Helvetica Neue Roman, TeXGyreHerosRegular,
      HelveticaNeueLocal, Helvetica, Tahoma, Geneva, Arial, sans-serif;
  }
  &-hall-name {
    margin-right: 5px;
  }
}

.time-wrapper {
  display: flex;
  align-items: center;
  background-size: 22px 22px;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  .time-date {
    display: block;
    margin-top: 15px;
    padding-left: 33px;
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg width='22' height='22' viewBox='0 0 22 22' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E666CB094-D402-4241-80E2-EEEC7E4DBD34%3C/title%3E%3Cdefs%3E%3Cpath id='b' d='M0 0h980v162H0z'/%3E%3Cfilter x='-50%25' y='-50%25' width='200%25' height='200%25' filterUnits='objectBoundingBox' id='a'%3E%3CfeOffset dy='1' in='SourceAlpha' result='shadowOffsetOuter1'/%3E%3CfeColorMatrix values='0 0 0 0 0.8 0 0 0 0 0.807843137 0 0 0 0 0.815686275 0 0 0 0.135303442 0' in='shadowOffsetOuter1'/%3E%3C/filter%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg opacity='.9' transform='translate(-68 -98)'%3E%3Cuse fill='%23000' filter='url(%23a)' xlink:href='%23b'/%3E%3Cuse fill='%2324262C' xlink:href='%23b'/%3E%3C/g%3E%3Cg fill='%23FFF'%3E%3Cpath d='M2 6v13c0 .556.445 1 1.001 1H19A1 1 0 0 0 20 19V6c0-.556-.445-1-1.001-1H3A1 1 0 0 0 2 6zM0 6a3 3 0 0 1 3.001-3H19A2.996 2.996 0 0 1 22 6v13a3 3 0 0 1-3.001 3H3A2.996 2.996 0 0 1 0 19V6z'/%3E%3Cpath d='M.5 11h21V9H.5zM5 1v5a1 1 0 1 0 2 0V1a1 1 0 1 0-2 0zM15 1v5a1 1 0 0 0 2 0V1a1 1 0 0 0-2 0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
      no-repeat 0 100%;
    background-size: 22px 22px;
    font-size: 16px;
    line-height: 24px;
    background-position: 0 0;
  }
}

.button-close {
  @extend %circle-btn;
  right: 25px;
  .btn-icon {
    // width: 26px;
    // height: 26px;
    background-position: 50% 50%;
  }
}

.step-box .input-wrapper input[type='text'][disabled],
.step-box .input-wrapper input[type='number'][disabled],
.step-box .input-wrapper input[type='email'][disabled],
.step-box .input-wrapper input[type='password'][disabled] {
  background-color: #a8a8a8 !important;
}
.step-box input[type='button'][disabled],
.step-box input[type='submit'][disabled] {
  color: #a8a8a8 !important;
  background: #3368ad !important;
}

.block-loading {
  background-image: url(/ajax-loader.gif);
  background-repeat: no-repeat;
  display: block;
  height: 25px;
  margin: 0;
  background-size: 25px;
  width: 25px;
  left: 5px;
  position: absolute;
  top: 10px;
}

.step-box .input-wrapper .input-info {
  color: #fff;
  text-align: center;
  margin-top: 5px;
  justify-self: center;
  display: block;
  font-size: 85%;
}

.input-error {
  p {
    font-size: 14px;
  }
  a {
    color: #a09d9d;
  }
}

.pz-close-btn {
  background: none;
  border: 1.55px solid white;
  position: absolute;
  top: 25px;
  right: 25px;
  width: 42px;
  height: 42px;
  display: block;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 18px;
    height: 18px;
    fill: white;
  }
}

.header .contact-label {
  text-align: end;
}

@media only screen and (min-width: 768px), screen and (orientation: landscape) {
  .header {
    height: 150px !important;
    padding: 26px 68px 27px;
    .contact {
      display: block;
    }
  }

  .cinema-wrapper {
    padding-right: 50%;
  }
}


@media only screen and (max-width: 480px), screen and (orientation: landscape) {
  .header {
    padding: 15px !important;
    height: auto !important;
  }
}

@media only screen and (max-width: 320px), screen and (orientation: landscape) {
  .header {
    position: static;
    top: 0;
    left: 0;
    right: 0;
    height: auto !important;
    padding: 15px !important;
  }
}

@media only screen and (max-height: 480px) {
  .header {
    padding: 10px !important;
  }

  .header .contact {
    top: 15px;
  }

  .session-wrapper .tag {
    margin-top: 0;
  }

  .session-wrapper .name {
    font-size: 16px;
  }

  .time-wrapper .time-date {
    margin-top: 10px;
    padding-left: 25px;
    background-size: 16px 16px;
    font-size: 14px;
    line-height: 24px;
    background-position: left center;
  }

  .cinema-wrapper {
    color: #919295;
    font-size: 12px;
  }
}
</style>
